import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    optIn: string,
    step: {
        success: {
            redirect: string,
        }
    }
};


export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    schoolName: 'School',
    infoShared1: ' ',
    informationTransferredToUS: ' ',
    infoShared2: 'Information entered here will be used for verification purposes and shared with {companyName}.',
    optIn: `By clicking, I consent to processing my information for the purpose of verifying my eligibility as described within the <a target="_blank" class="sid-link" href="https://www.sheerid.com/privacy-policy/">SheerID Privacy Policy</a> and the <a target="_blank" class="sid-link" href="https://www.lenovo.com/privacy/">Lenovo Privacy Statement</a>. I understand that my information will be shared with Lenovo. Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy and Lenovo's Privacy Statement.`,
    country: 'Country/Region',
    countries: {
        HK: 'Hong Kong S.A.R. of China',
        TW: 'Taiwan Region',
    },
    step: {
        success: {
            subtitle: 'Please click the button below to continue shopping. Your discount will be applied directly to your cart.',
            redirectButtonText: 'Continue to Lenovo',
            redirect: 'Continue to Lenovo',
            emailNotification: 'We have emailed this link to you so that you can continue shopping later. Look for the email from verify@sheerid.com.'
        },
    },
};
